import { createContext, useContext, type ReactNode } from 'react'

/** client: the client's own view. prep: staff prefilling. preview: staff viewing as the client, in practice mode (edits act as the client's and are never saved). */
export type Mode = 'client' | 'prep' | 'preview'
const Ctx = createContext<Mode>('client')

export function ModeProvider({ mode, children }: { mode: Mode; children: ReactNode }) {
  return <Ctx.Provider value={mode}>{children}</Ctx.Provider>
}
export function useMode(): Mode {
  return useContext(Ctx)
}
/** Whether the UI should show client affordances (prefilled tags, confirm toggles). */
export function useClientView(): boolean {
  return useMode() !== 'prep'
}
